<div class="icon-content">
  <div class="icon">
    <!--mat-icon class="material-icons-outlined">person</mat-icon-->
    <img class="image" width="50" src="/assets/images/person-white.png">
  </div>
</div>
<div class="text-center mt-4">
  <h3 class="title">¡LISTO!</h3>
  <label>Tu orden ha sido recibida y esta siendo procesada</label>
</div>